export type DesktopPlatform = "windows" | "darwin" | null;

export interface DesktopCapabilities {
  printer?: boolean;
  shortcuts?: boolean;
  commandPalette?: boolean;
  notifications?: boolean;
  updates?: boolean;
  [key: string]: boolean | undefined;
}

export interface DesktopEnv {
  isDesktop: boolean;
  version: string | null;
  platform: DesktopPlatform;
  capabilities: DesktopCapabilities;
  api: VedasDesktopApi | null;
}

const EMPTY_CAPABILITIES: DesktopCapabilities = Object.freeze({});

export function getDesktopEnv(): DesktopEnv {
  const api = typeof window !== "undefined" ? window.vedasDesktop : undefined;
  const isDesktop = api?.isDesktop === true;

  return {
    isDesktop,
    version: isDesktop ? api?.version ?? null : null,
    platform: isDesktop ? api?.platform ?? null : null,
    capabilities: isDesktop ? api?.capabilities ?? EMPTY_CAPABILITIES : EMPTY_CAPABILITIES,
    api: isDesktop ? api ?? null : null,
  };
}

export function isDesktopMode(): boolean {
  return getDesktopEnv().isDesktop;
}
